import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=988ed5ac&scoped=true&"
import script from "./TeamModal.vue?vue&type=script&lang=js&"
export * from "./TeamModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamModal.vue?vue&type=style&index=0&id=988ed5ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988ed5ac",
  null
  
)

export default component.exports